const ServiceNames = Object.freeze({
  TAX: "tax",
  PAYROLL: "payroll",
  BOOKKEEPING: "bookkeeping",
});

export default ServiceNames;
